import { useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Template2.css';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import supabase from '../utils/supabaseClient';
import { trackFormSubmission, trackEvent } from '../utils/analytics';

// comment to trigger build due to env variable for site redeirect on auth email

const sitekey = process.env.REACT_APP_HCAPTCHA_SITE_KEY;

function Auth() {
  const [email, setEmail] = useState('');
  const [captchaToken, setCaptchaToken] = useState(null);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const hcaptchaRef = useRef();
  const navigate = useNavigate();
  const location = useLocation();
  const redirect = new URLSearchParams(location.search).get('redirect') || '/';

  const getRedirectUrl = () => {
    let base;
    if (window.location.hostname === 'localhost') {
      base = 'http://localhost:8888';
    } else if (window.location.hostname.includes('staging--pipersofbelgrade.netlify.app')) {
      base = 'https://staging--pipersofbelgrade.netlify.app';
    } else {
      base = 'https://bagpipeblasphemy.com';
    }
    // Add the redirect param for post-login navigation
    return `${base}/auth/callback?redirect=${encodeURIComponent(redirect)}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!email) {
      setError('Please enter your email.');
      trackFormSubmission('auth_form', false);
      trackEvent('auth_form_error', { reason: 'missing_email' });
      return;
    }
    if (!captchaToken) {
      setError('Please complete the hCaptcha.');
      trackFormSubmission('auth_form', false);
      trackEvent('auth_form_error', { reason: 'hcaptcha_failed' });
      return;
    }
    setLoading(true);
    try {
      const { error: supabaseError } = await supabase.auth.signInWithOtp({
        email,
        options: {
          emailRedirectTo: getRedirectUrl(),
        },
      });
      if (supabaseError) throw supabaseError;
      setSuccess('Magic link sent! Please check your email.');
      trackFormSubmission('auth_form', true);
      trackEvent('auth_form_success', { email });
    } catch (err) {
      setError('Failed to send magic link.' + (err && err.message ? ' ' + err.message : ''));
      trackFormSubmission('auth_form', false);
      trackEvent('auth_form_error', { reason: 'supabase_error', message: err && err.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="template2-container">
      <div className="template2-content">
        <h1>Welcome! Let's Get Started.</h1>
        <h1>We'll send a magic link to your email.</h1>
        <form onSubmit={handleSubmit} style={{ maxWidth: 400, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 16 }}>
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            style={{ padding: 8, borderRadius: 4, border: '1px solid #ccc', fontSize: 16 }}
            required
            autoFocus
          />
          <HCaptcha
            sitekey={sitekey}
            onVerify={setCaptchaToken}
            ref={hcaptchaRef}
          />
          <button type="submit" disabled={loading} style={{ padding: 10, borderRadius: 4, background: '#333', color: '#fff', fontWeight: 600, fontSize: 16, border: 'none', cursor: 'pointer' }}>
            {loading ? 'Sending...' : 'Send Magic Link'}
          </button>
          {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}
          {success && <div style={{ color: 'green', marginTop: 8 }}>{success}</div>}
        </form>
      </div>
    </div>
  );
}

export default Auth; 